import type { RouteObject } from 'react-router-dom';
import { lazyElement } from '../routing/lazyRoute';

const apiLogRoutes: RouteObject[] = [
  {
    path: '/api-log/facility-users',
    element: lazyElement(() => import('./FacilityUserList')),
    handle: {
      documentTitle: 'Facility Users Log',
      crumb: () => ({ label: 'Facility Users Log', to: '/api-log/facility-users' })
    },
  },
  {
    path: '/api-log/staff-users',
    element: lazyElement(() => import('./StaffUserList')),
    handle: {
      documentTitle: 'Staff Users Log',
      crumb: () => ({ label: 'Staff Users Log', to: '/api-log/staff-users' })
    },
  },
];

export default apiLogRoutes;
